module.exports = __webpack_public_path__ + "img/3.97368ba0.png";